@if (loginFailed$  | async; as loginFailed) {
  <div class="col-12 no-gutters login-content-md text-md row">
    <div class="col-md-6 col-sm-12 login-content-right">
      <cx-page-slot position="CenterLeftContentSlot" class="p-0"></cx-page-slot>
    </div>
    <div class="col-md-6 col-sm-12 bg-petrol-light login-content-right">
      <cx-page-slot position="CenterRightContentSlot" class="p-0"></cx-page-slot>
      <button class="btn btn-primary btn-inline mt-3" (click)="cdcLogout()">
        {{ 'loginForm.logout' | cxTranslate }}
      </button>
    </div>
  </div>
} @else {
  <aimo-spinner></aimo-spinner>
}

